var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-list-item-label"},[_c('el-tooltip',{attrs:{"content":_vm.label.labelName,"placement":"top"}},[_c('font-awesome-icon',{staticClass:"content-label-icon mr-1",style:({ '--label-color': _vm.label.color }),attrs:{"icon":['fad', _vm.label.icon]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }